// import goTo from 'vuetify/lib/services/goto';

// const headerHeight = 112;
// const gap = 20;
const selectorError = '[data-has-error="true"]';

// eslint-disable-next-line no-unused-vars
export function scrollTo(elementSelector, parentElement, options = {}) {
    // eslint-disable-next-line no-unused-vars
    const field = (parentElement || document).querySelector(elementSelector);

    // TODO disabled for migration
    // field && goTo( field, {
    //     offset: headerHeight + gap,
    //     ...options
    // } );
    field &&
        field.scrollIntoView({
            behavior: 'smooth',
        });
}

export function scrollToFirstChildElementWithAttributeHasError(parentElement) {
    scrollTo(selectorError, parentElement);
}

export function focusFirstChildElementWithAttributeHasError(parentElement) {
    const field = (parentElement || document).querySelector(selectorError);

    field && field.focus && field.focus();
}
